import { render, staticRenderFns } from "./TranslateChecklist.vue?vue&type=template&id=4238fe85&scoped=true&"
import script from "./TranslateChecklist.vue?vue&type=script&lang=ts&"
export * from "./TranslateChecklist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4238fe85",
  null
  
)

export default component.exports